import { nanoid } from 'nanoid';
import React, { ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BiRefresh } from 'react-icons/bi';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import {
  BuscaProduto,
  InputPeso,
  InputSelect,
  Loja,
} from '~/components/NovosInputs';
import { insertOrUpdate } from '~/utils/masterDetail';
import { useMoviProducao } from '../../hooks/useMoviProducao';
import { servicesMovProd } from '../../services';
import { rowProps } from '../../types';

export const Form: React.FC = () => {
  const {
    formTela: {
      register,
      control,
      formState: { errors },
      getValues,
      setValue,
      watch,
      clearErrors,
    },
    isUpdate,
    loadingButton,
    setRows,
    ajustePais,
    resetFormData,
    ajusteFilhos,
    setLoadingTable,
    masterDetail,
    setMasterDetail,
    handleCalcular,
    disabledProd,
    setDisabledProd,
  } = useMoviProducao();
  const { getProductsProd } = servicesMovProd;

  const handleInvalidProduct = async () => {
    await Swal.fire({
      title: `Produto está marcado como explosão na venda!`,
      text: `Permitido apenas produtos de produção que NÃO explodem na venda.
         Regularize a situação para prosseguir`,
      showDenyButton: false,
      confirmButtonText: 'OK',
    });
  };

  const handleAddProduto = async (selected: any) => {
    const invalidProduct = selected.filter(
      (i: rowProps) => i.flg_explosao_venda,
    );
    if (invalidProduct.length > 0) return handleInvalidProduct();
    try {
      setLoadingTable(true);
      const { data, success } = await getProductsProd(
        selected[0].cod_produto,
        selected[0].cod_loja,
      );
      if (data.length <= 0) {
        setLoadingTable(false);
        return toast.warn('Não há produtos vinculados a esta produção');
      }

      if (success) {
        const rowsFix: any = data.map((i: rowProps) => {
          const uuid = nanoid();
          return {
            ...i,
            uuid,
            val_custo_producao: i.qtd_producao * i.val_custo_rep,
          };
        });

        const rowsDetail: any = await insertOrUpdate(
          'produtos',
          rowsFix,
          masterDetail,
          setMasterDetail,
        );
        setRows(rowsDetail.flat());
        setDisabledProd(true);
      }
    } catch (error: any) {
      toast.warning(error.message);
    } finally {
      setLoadingTable(false);
    }
  };

  const handleCancelSearch = () => {
    setDisabledProd(false);
    resetFormData();
    const input = document.getElementById('busca_produto') as HTMLInputElement;
    setTimeout(() => {
      input?.click();
      input?.focus();
    }, 50);
  };

  return (
    <>
      <Row>
        <Col md={12} sm={12}>
          <Loja
            label="Loja *"
            name="cod_loja"
            placeholder="Selecione..."
            register={register}
            control={control}
            isError={false}
            getValues={getValues}
            disabled={isUpdate}
            changeSelected={(ev) => {
              setValue('cod_loja', ev);
            }}
          />
        </Col>
      </Row>
      <Row className="align-items-end">
        <Col style={{ flex: 1 }}>
          <BuscaProduto
            id="busca_produto"
            label="Buscar Produto Acabado *"
            placeholder="Selecione..."
            name="busca_produto"
            register={register}
            disabled={disabledProd || isUpdate}
            isError={!!errors.busca_produto}
            control={control}
            buscaNasLojas={watch('cod_loja')?.value}
            setValue={setValue}
            customOptions={{
              hideBuscarPor: true,
              showSelecionarItensContendo: false,
              buscarPor: ['Produto'],
              filterByTipoMov: 3,
            }}
            getProduct={(selected) => {
              handleAddProduto(selected);
            }}
          />
        </Col>

        <Col xs="auto">
          <CustomButtonNovo
            variant="error"
            disabled={isUpdate}
            label="Cancelar"
            onClick={handleCancelSearch}
          />
        </Col>
      </Row>
      <Row className="mt-4 gs-4 align-items-end">
        <Col style={{ flex: 2 }}>
          <InputSelect
            label="Tipo de Ajuste - Pai *"
            name="cod_tipo_ajuste_pai"
            placeholder="Selecione..."
            register={register}
            control={control}
            disabled={isUpdate}
            isError={!!errors.cod_tipo_ajuste_pai}
            options={ajustePais}
            changeSelected={(selected) => {
              clearErrors('cod_tipo_ajuste_pai');
              setValue('cod_tipo_ajuste_pai', selected);
            }}
          />
        </Col>

        <Col style={{ flex: 2 }}>
          <InputSelect
            label="Tipo de Ajuste - Filhos *"
            name="cod_tipo_ajuste_filho"
            placeholder="Selecione..."
            register={register}
            control={control}
            disabled={isUpdate}
            isError={!!errors.cod_tipo_ajuste_filho}
            options={ajusteFilhos}
            changeSelected={(selected) => {
              clearErrors('cod_tipo_ajuste_filho');
              setValue('cod_tipo_ajuste_filho', selected);
            }}
          />
        </Col>

        <Col style={{ flex: 1 }}>
          <InputPeso
            label="Quantidade *"
            name="qtd_producao"
            placeholder="0,000"
            decimals={3}
            max={9999}
            min={0.001}
            maxLength={12}
            control={control}
            register={register}
            disabled={isUpdate}
            isError={!!errors.qtd_producao}
            onInput={(e: ChangeEvent<HTMLInputElement>) => {
              clearErrors('qtd_producao');
              setValue('qtd_producao', e.target.value);
            }}
          />
        </Col>

        <Col xs="auto">
          <CustomButtonNovo
            variant="confirm"
            showLoading={loadingButton}
            disabled={isUpdate}
            icon={BiRefresh}
            label="Calcular"
            onClick={handleCalcular}
          />
        </Col>
      </Row>
    </>
  );
};
